export enum DeviceLoadState {
    Initial = 'Initial',
    Loading = 'Loading',
    Success = 'Success',
    Error = 'Error',
};
